import React, { useEffect } from 'react';
import AppRoutes from 'routes/AppRoutes';
import { BrowserRouter } from 'react-router-dom';

const App = () => {
  useEffect(() => {
    const handleUnload = () => {
      sessionStorage.removeItem('accessToken');
    };

    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, []);

  return (
    <BrowserRouter basename="/admin">
      <AppRoutes />
    </BrowserRouter>
  );
};

export default App;
